import { Grid2 } from '@mui/material';
import { Controller, useFormContext } from 'react-hook-form';
import moment from 'moment/moment';
import { useEffect } from 'react';
import ExpenseDatePicker from './ExpenseDatePicker';
import { COLORS } from '../../../utils/Application_Constants';
import eventBus from './EventBus';
import { ExpenseCategoryEnum } from './ExpenseCategory.enum';
import { getSqlMinDate, getSqlMaxDate } from './DateConstraints';

const VendorPaymentStartDate = (props) => {
    const {
        index,
        isViewOnly,
        isInvoiceReviewLocked = false,
        expense,
        specialLabel = 'Start Date',
    } = props;
    const { control, errors, watch } = useFormContext();
    const expenseCategory = watch(`expenseEntries[${index}].category`);
    const isTravelExpense = expenseCategory === ExpenseCategoryEnum.Travel;

    // Business logic constraints for travel expenses
    const businessMaxDate = isTravelExpense ? moment().add(6, 'months').endOf('day') : undefined;
    const businessMinDate = isTravelExpense
        ? moment().subtract(6, 'months').startOf('day')
        : undefined;

    // Get fresh SQL constraint objects to prevent mutation
    const sqlMinDate = getSqlMinDate();
    const sqlMaxDate = getSqlMaxDate();

    // Apply the most restrictive constraints
    const maxStartDate =
        businessMaxDate && businessMaxDate.isBefore(sqlMaxDate) ? businessMaxDate : sqlMaxDate;
    const minStartDate =
        businessMinDate && businessMinDate.isAfter(sqlMinDate) ? businessMinDate : sqlMinDate;

    useEffect(() => {
        if (expense.startDate) {
            eventBus.emit(`startDateChanged${index}`, {
                data: moment(expense.startDate).startOf('day').format('YYYY-MM-DD'),
            });
        }
    }, []);

    return (
        <Grid2 item>
            <Controller
                control={control}
                name={`expenseEntries[${index}].startDate`}
                defaultValue={expense.startDate || null}
                rules={{
                    required: 'Start Date is required. Please enter a valid date.',
                    validate: {
                        maxDate: (value) => {
                            if (!value || !maxStartDate) return true;
                            if (moment(value).isAfter(maxStartDate)) {
                                return `Start date must be within ${maxStartDate.diff(
                                    moment().startOf('day'),
                                    'months'
                                )} months`;
                            }
                            return true;
                        },
                        minDate: (value) =>
                            !minStartDate ||
                            !value ||
                            moment(value).isSameOrAfter(minStartDate) ||
                            'Minimum date reached',
                    },
                }}
                disabled={isViewOnly || isInvoiceReviewLocked}
                render={({ onChange, value }) => (
                    <ExpenseDatePicker
                        onChange={(e) => {
                            if (e?.isValid()) {
                                eventBus.emit(`startDateChanged${index}`, {
                                    data: e.startOf('day').format('YYYY-MM-DD'),
                                });
                            }
                            onChange(e);
                        }}
                        disabled={isViewOnly || isInvoiceReviewLocked}
                        value={moment(value)}
                        id={`start-date-${index}`}
                        label={specialLabel}
                        required
                        minDate={minStartDate}
                        maxDate={maxStartDate}
                        parentTextFieldProps={{
                            error: Boolean(errors.expenseEntries?.[index]?.startDate),
                            helperText: errors.expenseEntries?.[index]?.startDate?.message,
                        }}
                        parentSx={{
                            '& .MuiPickersInputBase-root': {
                                borderColor: !errors.expenseEntries?.[index]?.startDate
                                    ? 'default'
                                    : `${COLORS.LT_PEPPER} !important`,
                            },
                        }}
                    />
                )}
            />
        </Grid2>
    );
};

export default VendorPaymentStartDate;
